<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-service'></i> 客服中心</el-breadcrumb-item>
                <el-breadcrumb-item>Q&amp;A问题</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='20'>
                        <el-form :inline='true' :model='queryParams' size='small'>
                            <el-form-item label='项目'>
                                <el-select v-model='queryParams.projectAppId' filterable clearable
                                           placeholder='请先选择项目' @change='handleProjectChange'>
                                    <el-option v-for='item in projectInfoList' :key='item.appId' :label='item.cnName'
                                               :value='item.appId' />
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if='queryParams.projectAppId' label='分组'>
                                <el-select v-model='queryParams.groupId' filterable clearable placeholder='分组'
                                           @change='handleGroupChange'>
                                    <el-option v-for='item in groupList' :key='item.id'
                                               :label='getMappingPreview(item.nameMapping)' :value='item.id' />
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if='queryParams.projectAppId' label='状态'>
                                <el-select v-model='queryParams.status' clearable placeholder='状态'>
                                    <el-option label='启用' :value='1' />
                                    <el-option label='停用' :value='0' />
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type='primary' icon='el-icon-search' :disabled='!queryParams.projectAppId'
                                           @click='handleQuery'>搜索
                                </el-button>
                                <el-button v-if='queryParams.projectAppId' icon='el-icon-refresh' @click='resetQuery'>
                                    重置
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='4' class='table-actions'>
                        <el-button v-if='queryParams.projectAppId' type='primary' plain icon='el-icon-plus'
                                   @click='handleAdd'>新增
                        </el-button>
                    </el-col>
                </el-row>
            </div>
            
            <div v-if='queryParams.projectAppId'>
                <el-alert
                    class='sort-tip'
                    :title="queryParams.groupId ? '当前可拖拽排序，排序仅在所选分组内生效' : '请选择分组后再拖拽排序，未选择分组时仅支持查看和编辑'"
                    :type="queryParams.groupId ? 'success' : 'warning'"
                    show-icon
                    :closable='false'>
                </el-alert>
                <el-table ref='dataTable' v-loading='loading' :data='tableList' row-key='id'
                          :cell-style="{ textAlign: 'center' }" :header-cell-style="{ textAlign: 'center' }">
                    <el-table-column width='50' label=''>
                        <template><i class='el-icon-rank'
                                     :class="queryParams.groupId ? 'drag-handle' : 'drag-handle-disabled'"></i>
                        </template>
                    </el-table-column>
                    <el-table-column label='排序' prop='sort' width='80' />
                    <el-table-column label='分组'>
                        <template slot-scope='scope'>{{ groupMap.get(scope.row.groupId) }}</template>
                    </el-table-column>
                    <el-table-column label='问题' show-overflow-tooltip>
                        <template slot-scope='scope'>{{ getMappingPreview(scope.row.questionMapping) }}</template>
                    </el-table-column>
                    <el-table-column label='状态' width='90'>
                        <template slot-scope='scope'>
                            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
                                {{ scope.row.status === 1 ? '启用' : '停用' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label='更新时间' prop='updateTime' show-overflow-tooltip />
                    <el-table-column label='操作' width='160' fixed='right'>
                        <template slot-scope='scope'>
                            <el-button type='text' icon='el-icon-edit' @click='handleUpdate(scope.row)'>修改</el-button>
                            <el-button type='text' icon='el-icon-delete' @click='handleDelete(scope.row)'>删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div class='pagination'>
                    <el-pagination
                        :current-page='queryParams.pageNum'
                        :page-size='queryParams.pageSize'
                        :total='queryParams.total'
                        background
                        layout='total, prev, pager, next'
                        @current-change='handlePagination'>
                    </el-pagination>
                </div>
            </div>
            <div v-else class='select-project-empty'>请先选择项目</div>
            
            <el-dialog :title='title' :visible.sync='open' append-to-body width='760px' :before-close='cancel'>
                <el-form ref='form' :model='form' label-width='90px'>
                    <el-form-item label='分组'>
                        <el-select v-model='form.groupId' filterable placeholder='请选择分组'>
                            <el-option v-for='item in formGroupList' :key='item.id'
                                       :label='getMappingPreview(item.nameMapping)' :value='item.id' />
                        </el-select>
                    </el-form-item>
                    <el-form-item label='状态'>
                        <el-switch v-model='form.status' :active-value='1' :inactive-value='0' active-text='启用'
                                   inactive-text='停用' />
                    </el-form-item>
                    <el-form-item label='内容'>
                        <el-tabs v-model='activeLanguage'>
                            <el-tab-pane v-for='item in languageOptions' :key='item.value' :label='item.label'
                                         :name='item.value'>
                                <el-form-item label='问题' label-width='60px'>
                                    <el-input v-model='form.questionMapping[item.value]'
                                              :placeholder='`请输入${item.label}问题`' />
                                </el-form-item>
                                <el-form-item label='答案' label-width='60px'>
                                    <el-input v-model='form.answerMapping[item.value]' type='textarea' :rows='6'
                                              :placeholder='`请输入${item.label}答案`' />
                                </el-form-item>
                            </el-tab-pane>
                        </el-tabs>
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确定</el-button>
                    <el-button @click='cancel'>取消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>
import { customerQaApi, customerQaGroupApi } from '@api/customer';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import { message } from '@/utils/message';
import { deepCopy } from '@/utils/object';

export default {
    name: 'CustomerQa',
    data() {
        return {
            loading: false,
            open: false,
            updateStatus: false,
            title: '',
            activeLanguage: 'zh-CN',
            tableList: [],
            groupList: [],
            formGroupList: [],
            groupMap: new Map(),
            projectInfoList: [],
            queryParams: {
                pageNum: 1,
                pageSize: 15,
                total: 0,
                projectAppId: undefined,
                groupId: undefined,
                status: undefined,
                sortSqlList: ['sort asc', 'id desc']
            },
            form: {
                questionMapping: {
                    'zh-CN': '',
                    'en-US': ''
                },
                answerMapping: {
                    'zh-CN': '',
                    'en-US': ''
                }
            },
            languageOptions: [
                { label: '简体中文', value: 'zh-CN' },
                { label: 'English', value: 'en-US' }
            ]
        };
    },
    created() {
        this.queryProjectList();
    },
    methods: {
        queryProjectList() {
            queryProjectInfoList({ pageSize: 100000 }).then(response => {
                if (response.code === 200 && response.data && response.data.result) {
                    this.projectInfoList = response.data.result;
                }
            });
        },
        queryGroupList(projectAppId, target) {
            if (!projectAppId) {
                if (target === 'form') {
                    this.formGroupList = [];
                } else {
                    this.groupList = [];
                    this.groupMap = new Map();
                }
                return;
            }
            customerQaGroupApi.query({
                pageSize: 100000,
                projectAppId,
                sortSqlList: ['sort asc', 'id desc']
            }).then(response => {
                if (response.code === 200 && response.data && response.data.result) {
                    const list = response.data.result;
                    if (target === 'form') {
                        this.formGroupList = list;
                    } else {
                        this.groupList = list;
                        this.groupMap = new Map();
                        list.forEach(item => this.groupMap.set(item.id, this.getMappingPreview(item.nameMapping)));
                    }
                }
            });
        },
        getList() {
            if (!this.queryParams.projectAppId) {
                this.tableList = [];
                this.queryParams.total = 0;
                return;
            }
            this.loading = true;
            customerQaApi.query(this.queryParams).then(response => {
                if (response.code === 200) {
                    this.tableList = response.data.result || [];
                    this.queryParams.total = response.data.total;
                    this.queryParams.pageNum = response.data.pageNum;
                    this.$nextTick(this.bindDrag);
                }
                this.loading = false;
            });
        },
        submitForm() {
            if (!this.form.groupId) {
                message.error('请选择分组');
                return;
            }
            if (!this.hasMappingValue(this.form.questionMapping)) {
                message.error('请至少填写一个问题');
                return;
            }
            if (!this.hasMappingValue(this.form.answerMapping)) {
                message.error('请至少填写一个答案');
                return;
            }
            this.form.projectAppId = this.queryParams.projectAppId;
            const request = this.updateStatus ? customerQaApi.update : customerQaApi.insert;
            request(this.form).then(response => {
                if (response.code === 200) {
                    message.success(this.updateStatus ? '修改成功' : '新增成功');
                    this.open = false;
                    this.getList();
                }
            });
        },
        handleAdd() {
            if (!this.queryParams.projectAppId) {
                message.error('请先选择项目');
                return;
            }
            this.title = '新增Q&A问题';
            this.updateStatus = false;
            this.activeLanguage = 'zh-CN';
            this.form = {
                projectAppId: this.queryParams.projectAppId,
                groupId: this.queryParams.groupId,
                status: 1,
                sort: this.queryParams.total + 1,
                questionMapping: this.createEmptyMapping(),
                answerMapping: this.createEmptyMapping()
            };
            this.formGroupList = this.groupList.slice();
            this.open = true;
        },
        handleUpdate(row) {
            this.title = '修改Q&A问题';
            this.updateStatus = true;
            this.activeLanguage = 'zh-CN';
            this.form = deepCopy(row);
            this.form.questionMapping = Object.assign(this.createEmptyMapping(), this.form.questionMapping || {});
            this.form.answerMapping = Object.assign(this.createEmptyMapping(), this.form.answerMapping || {});
            this.formGroupList = this.groupList.slice();
            this.open = true;
        },
        handleDelete(row) {
            this.$confirm(`确认删除"${this.getMappingPreview(row.questionMapping)}"吗？`, '提示', { type: 'warning' }).then(() => {
                customerQaApi.deleteData({ id: row.id }).then(response => {
                    if (response.code === 200) {
                        message.success('删除成功');
                        this.getList();
                    }
                });
            });
        },
        handleProjectChange(value) {
            this.queryParams.groupId = undefined;
            this.queryParams.status = undefined;
            this.queryParams.pageNum = 1;
            this.queryGroupList(value);
            this.getList();
        },
        handleGroupChange() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        resetQuery() {
            const projectAppId = this.queryParams.projectAppId;
            this.queryParams = {
                pageNum: 1,
                pageSize: 15,
                total: 0,
                projectAppId,
                groupId: undefined,
                status: undefined,
                sortSqlList: ['sort asc', 'id desc']
            };
            this.getList();
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        cancel() {
            this.open = false;
        },
        createEmptyMapping() {
            const mapping = {};
            this.languageOptions.forEach(item => {
                mapping[item.value] = '';
            });
            return mapping;
        },
        hasMappingValue(mapping) {
            return mapping && Object.keys(mapping).some(key => mapping[key]);
        },
        getMappingPreview(mapping) {
            if (!mapping) {
                return '';
            }
            return mapping['zh-CN'] || mapping['en-US'] || Object.values(mapping).find(item => item) || '';
        },
        bindDrag() {
            const table = this.$refs.dataTable;
            if (!table || !table.$el) {
                return;
            }
            const rows = table.$el.querySelectorAll('.el-table__body-wrapper tbody tr');
            if (!this.queryParams.groupId) {
                rows.forEach(row => {
                    row.draggable = false;
                    row.ondragstart = null;
                    row.ondragover = null;
                    row.ondrop = null;
                });
                return;
            }
            rows.forEach((row, index) => {
                row.draggable = true;
                row.dataset.index = index;
                row.ondragstart = event => {
                    event.dataTransfer.setData('text/plain', index);
                };
                row.ondragover = event => event.preventDefault();
                row.ondrop = event => {
                    event.preventDefault();
                    const oldIndex = Number(event.dataTransfer.getData('text/plain'));
                    const newIndex = Number(row.dataset.index);
                    this.handleDragSort(oldIndex, newIndex);
                };
            });
        },
        handleDragSort(oldIndex, newIndex) {
            if (!this.queryParams.groupId) {
                message.error('请先选择分组后再排序');
                return;
            }
            if (oldIndex === newIndex || oldIndex < 0 || newIndex < 0) {
                return;
            }
            const list = this.tableList.slice();
            const moved = list.splice(oldIndex, 1)[0];
            list.splice(newIndex, 0, moved);
            const offset = (this.queryParams.pageNum - 1) * this.queryParams.pageSize;
            this.tableList = list.map((item, index) => Object.assign({}, item, { sort: offset + index + 1 }));
            this.tableList.forEach(item => customerQaApi.update({ id: item.id, sort: item.sort }));
            this.$nextTick(this.bindDrag);
        }
    }
};
</script>

<style scoped>
.table-actions {
    text-align: right;
}

.drag-handle {
    cursor: move;
}

.drag-handle-disabled {
    color: #c0c4cc;
    cursor: not-allowed;
}

.sort-tip {
    margin-bottom: 12px;
}

.select-project-empty {
    color: #909399;
    padding: 80px 0;
    text-align: center;
}
</style>
